export default __webpack_public_path__ + "static/media/2.ffbfd3c0.png";